import { TimerModel } from "src/models/timer.model";

export enum TimerChangeAction {
  START = "START",
  CANCEL = "CANCEL",
  RESET = "RESET",
  UPDATE = "UPDATE",
  FINISH = "FINISH",
}

export type TimerChangeModel = {
  action: TimerChangeAction;
  timer: TimerModel;
};
